// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__rD_ea","video":"styles_video__O1PLs"};